import { TActionsWithoutState } from '../Interfaces/TActionsWithoutState';
import updateRoundTee from './actions/updateRoundTee';
import createRoundTee from './actions/createRoundTee';
import deleteRoundTee from './actions/deleteRoundTee';
import removeRoundTee from './actions/removeRoundTee';
import getRoundTees from './actions/getRoundTees';

const actions = {
  createRoundTee,
  deleteRoundTee,
  getRoundTees,
  removeRoundTee,
  updateRoundTee
};

export type IRoundTeesActions = TActionsWithoutState<typeof actions>;

export default actions;
